/**
 * Constantes FHIR para Tasks de envio de questionário (workflow).
 *
 * Perfil mínimo:
 * - `status`: `requested` = paciente ainda não marcou como respondido; `completed` = respondido (lado paciente).
 * - `code.coding`: identifica a task no filtro de UI e nas notificações do profissional.
 * - `focus`: referência ao `Questionnaire/{id}` para abrir o formulário no futuro.
 * - `owner`: organização responsável (obrigatório no produto).
 * - `requester`: PractitionerRole de quem disparou o envio (obrigatório).
 * - `for`: paciente alvo (Patient/{id}).
 * - `identifier` (opcional, um item): quando o envio vier de um agendamento conhecido,
 *   `system` = `QUESTIONNAIRE_TASK_SCHEDULING_APPOINTMENT_IDENTIFIER_SYSTEM` e
 *   `value` = id **lógico** do `Appointment` no servidor de scheduling (texto **puro**, sem prefixo `Reference`).
 *   Omitir em envios ad hoc (sem consulta no fluxo) ou quando não houver id coerente
 *   (mesma regra de placeholders que antes filtrava `basedOn`; consultar
 *   `resolveOptionalAppointmentIdentifierValue` no service).
 *
 * Tasks antigas podem ter apenas `basedOn` → `Appointment/{id}`; a leitura na UI faz
 * fallback para esse campo até as tasks serem todas migradas.
 */

/**
 * NamingSystem Fluxmed para o id de `Appointment` no servidor de scheduling.
 * Armazenado na Task como `identifier` (não usar `basedOn` entre servidores distintos).
 */
export const QUESTIONNAIRE_TASK_SCHEDULING_APPOINTMENT_IDENTIFIER_SYSTEM =
  "https://fluxmed.com.br/fhir/NamingSystem/scheduling-appointment-id";

/** System alinhado a outros task-types do legado (ex.: CreateMedicationTask). */
export const QUESTIONNAIRE_TASK_CODE_SYSTEM =
  "https://fluxmed.com.br/fhir/CodeSystem/task-types";

/** Código estável para filtrar tasks de questionário em listas e SSE. */
export const QUESTIONNAIRE_TASK_CODE = "QUESTIONNAIRE_PENDING";

/** Texto humano padrão do CodeableConcept (notificações / listas). */
export const QUESTIONNAIRE_TASK_CODE_TEXT = "Questionário pendente";
